import { createCommand } from '@commander-js/extra-typings';
import type {
  CommandServices,
  GetRootCommandFn,
} from '@wix/cli-command-contract';

import { buildCommand } from './build.js';
import { connectCommand } from './connect.js';
import { envCommand } from './env.js';
import { previewCommand } from './preview.js';
import { promoteCommand } from './promote.js';
import { releaseCommand } from './release.js';
import { devCommand } from './dev.js';
import { generateCommand } from './generate.js';
import { translationCommand } from './translation.js';
import { skillsCommand } from './skills.js';

export const getRootCommand: GetRootCommandFn = async (
  services: CommandServices,
  cliVersion: string
) => {
  return createCommand('astro')
    .enablePositionalOptions(true)
    .addCommand(buildCommand(services, cliVersion))
    .addCommand(connectCommand(services, cliVersion))
    .addCommand(envCommand(services, cliVersion))
    .addCommand(previewCommand(services, cliVersion))
    .addCommand(skillsCommand(services, cliVersion))
    .addCommand(promoteCommand(services, cliVersion), { hidden: true })
    .addCommand(releaseCommand(services, cliVersion))
    .addCommand(devCommand(services, cliVersion))
    .addCommand(generateCommand(services, cliVersion))
    .addCommand(translationCommand(services, cliVersion), { hidden: true });
};
